/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {InputComponent} from '../input/input.component';

@Component({
    selector: 'app-input-text',
    templateUrl: './input-text.component.html',
    styleUrls: [
        '../input/input.component.css',
        './input-text.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputTextComponent extends InputComponent implements OnInit, OnDestroy {
    @Input() isToUpperCaseInputTextValue = false;

    constructor(protected formBuilder: UntypedFormBuilder) {
        super(formBuilder);
    }

    hasIconButton(): boolean {
        return this.hasDeleteButton || this.hasSearchIcon;
    }

    get upperCaseClass(): string {
        let cssClass = '';

        if (this.isToUpperCaseInputTextValue) {
            cssClass = 'upper-case-input-text';
        }

        return cssClass;
    }
}
